import React, { useState, useEffect } from 'react';
import { Card, Form, Input, Space, Button,message,Tag } from 'antd';
import { useSupplierEntry } from '../../../hooks/supplier-entry';
import { debounce } from 'lodash';
import { decryptTextByAES } from '../../../utils/encryption'
import CountdownTimer from '../../base/SPCountdownTimer'

interface props {
  supplierInfo?: any
  enums?: any
  refresh?: any
  nextStep?: any
  preStep?:any
}

const SPSignContract: React.FC<props> = (props) => {
  const { supplierInfo, enums,refresh,nextStep,preStep } = props

  const [mainForm] = Form.useForm();
  const { getContract,getVerifyCode,confirmSign } = useSupplierEntry();
  const [contractUrl, setContractUrl] = useState<any>()
  const [isSign, setIsSign] = useState<boolean>(false)

  useEffect(() => {
    getContract().then((res) => {
      setContractUrl(res.data)
    })
    setIsSign(supplierInfo.entering_status == 5 && supplierInfo?.pay_deposit_status === 0)
  }, []);


  const signClick = debounce(() => {
    if (!mainForm.getFieldValue('code')) {
      return message.warning('请输入验证码')
    }
    confirmSign(mainForm.getFieldsValue()).then((res: any) => {
      if (res.errno == 0) {
        message.success('签约成功')
        nextStep(2)
      }
    })
  }, 2000, {
    leading: true, // 在调用时立即执行函数
    trailing: false // 防止在等待时间后再次执行函数
  })

    return (
      < >
        <Card title={(
            <div>
              <span>商户号入网签约</span>
              <Tag color={isSign ? 'green' : 'orange'}>{enums.entering_status.find((item:any) => item.key == supplierInfo.entering_status).value}</Tag>
            </div>
          )
        } bodyStyle={{display:'flex',justifyContent:'center',flexWrap:'wrap'}}>
          <div style={{width:'100%',display:'flex',justifyContent:'center'}}>
            <iframe
            src={contractUrl} //文件地址
            style={{width:'90%',height:900,margin:'20px 0'}}
            />
          </div>
          <Form labelCol={{ style: { width: '130px' } }} form={mainForm}>
            <Form.Item
              label="签约手机号"
              extra={
                  isSign?null:<span style={{color: 'rgb(255, 100, 0)'}}>验证码将发送至该手机号中</span>
              }
            >
              <Input disabled value={decryptTextByAES(supplierInfo.legal_person_agent_cfg?.legal_person_agent_cell_phone_encrypt)}></Input>
            </Form.Item>
            {isSign ? null : <Space align="baseline">
              <Form.Item
                label="验证码"
                name="code"
              >
                <Input></Input>
              </Form.Item>
              <CountdownTimer startTimerFinish={() => getVerifyCode()} initialSeconds={60} />
            </Space>}
          </Form>
          <Space style={{width:'100%',display:'flex',justifyContent:'center'}}>
            <Button type='primary' onClick={() => preStep(0)}>上一步</Button>
            {isSign ? null : <Button type='primary' onClick={signClick}>确认签约</Button>}
            {isSign ? <Button type='primary' onClick={() => nextStep(2)}>下一步</Button> : null}
          </Space>
        </Card>
      </>
    )
}

export default SPSignContract
